import { deleteProperty } from "@/services/helpers";

export const setItemsLoading = (state, payload) => {
  payload.forEach((item) => {
    state.itemsLoading.push(item.batch_id);
  });
};

export const addItems = (state, payload) => {
  payload.forEach((item) => {
    if (state.itemsLoading.includes(item.batch_id)) {
      state.itemsLoading = state.itemsLoading.filter((loadingItem) => loadingItem !== item.batch_id);
    }
  });

  state.order.items = payload;
};

export const clearItemsLoading = (state, payload) => {
  state.itemsLoading = [];
};

export const addTask = (state, payload) => {
  state.order.task_checklist.push(payload);
};

export const updateTask = (state, payload) => {
  const updatedTasks = state.order.task_checklist.map((task) => {
    if (task.id == payload.id) {
      return payload;
    }
    return task;
  });
  // updatedTasks.push(payload);
  state.order.task_checklist = updatedTasks;
};

export const orderLoaded = (state, payload) => {
  state.order = payload;
};

export const replaceOrder = (state, payload) => {
  state.order = payload;
};

export const reset = (state, payload) => {
  state.order = {};
  state.itemsLoading = [];
};

export const deleteBuyerNote = (state, payload) => {
  state.order.buyer_note = undefined;
};

export const updateOrderQbData = (state, payload) => {
  const order = state.order;
  let currentItems = [];
  if (order.buyer) {
    order.buyer.quickbooks_customer_id = payload.quickBooksCustomerId;
  }
  if (payload.products && payload.products.length > 0) {
    payload.products.forEach((product, indexCurrentProduct) => {
      currentItems = [];
      currentItems = order.items.filter((orderItem) => orderItem.product_id == product.id);
      if (currentItems && currentItems.length > 0) {
        currentItems.forEach((currentItem, indexCurrentItem) => {
          currentItem.original_product.quickbooks_product_id = product.quickbooks_product_id;
        });
      }
    });
  }
};

export const removeOrderQbInvoice = (state, payload) => {
  const order = state.order;
  const invoice = payload.quickbooksInvoice;
  // Unlinking can happen off the order page (QuickBooks integration page) where no order is
  // loaded. Only update the on-screen order when it holds the affected invoice.
  if (!order || !Array.isArray(order.quickbooks_invoices) || !invoice) return;
  order.quickbooks_invoices = order.quickbooks_invoices.filter((qbi) => qbi.id != invoice.id);
};

export const addOrderQbInvoice = (state, payload) => {
  const order = state.order;
  const invoice = payload.quickbooksInvoice;
  // Linking can happen off the order page (QuickBooks integration page) where no order — or a
  // different one — is loaded. Only update the on-screen order when it is the linked one.
  if (!order || !Array.isArray(order.quickbooks_invoices) || !invoice) return;
  if (order.id != invoice.order_id) return;
  order.quickbooks_invoices.push(invoice);
};

/** Transporter lines are saved on their own, so only they change here; the rest of the order stays as stored. */
export const setOrderTransporters = (state, payload) => {
  state.order.transporters = payload;
};

export const updateOrderTransferId = (state, payload) => {
  const order = state.order;
  order.metrc_transfer_template_id = payload.metrcTransferTemplateId;
};

export const created = (state, payload) => {
  state.order = payload;
};
